export default function initHeader() {
    const message='this is a test'
    jQuery('#message').on('click',() => {
        alert(message)
    })
}